import { EComValidationProps } from '.';

export const getMountProps = (filters: HistoryFilter, elementProps: EComValidationProps[]) => {
  const baseGetCrumbsFunction = () => [
    {
      type: 'ui_tab',
      text: 'Settings',
      name: 'admin',
    },
  ];

  const value = getValue(elementProps).trim();

  if (filters.name === 'admin.views.class') {
    return {
      getCrumbs: () => [
        {
          type: 'ui_tab',
          text: 'Settings',
          name: 'admin',
        },
        {
          type: 'listing',
          name: 'admin.listings.classes',
          text: 'Tax Classes',
        },
        {
          text: `Class: ${value || 'New'}`,
        },
      ],
    };
  }

  if (filters.name === 'admin.views.sales_tax') {
    return {
      getCrumbs: () => [
        {
          type: 'ui_tab',
          text: 'Settings',
          name: 'admin',
        },
        {
          type: 'listing',
          name: 'admin.listings.sales_taxes',
          text: 'Sales Taxes',
        },
        {
          text: `Tax Category: ${value || 'New'}`,
        },
      ],
    };
  }

  if (filters.name === 'admin.views.employee') {
    return {
      getCrumbs: () => [
        {
          type: 'ui_tab',
          text: 'Settings',
          name: 'admin',
        },
        {
          type: 'listing',
          name: 'admin.views.employee',
          text: 'Employees',
        },
        {
          text: `Employee: ${value || 'New'}`,
        },
      ],
    };
  }

  return {
    getCrumbs: baseGetCrumbsFunction,
  };
};

const getValue = (arg: EComValidationProps[]) => {
  return arg
    .map((obj) => {
      const {
        inputProps: { value },
      } = obj;
      return value;
    })
    .join(' ');
};
